import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { __decorate } from "tslib";
import { saveAddress, addressList, deleteAdress, pageVisit as _pageVisit, getDataAddress } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import NavMenu from '@/common/navmenu.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { validateTelPhone } from '@/tools/regexp';
import addData from '../../assets/json/address.json';
import { readCookie } from '../../tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.dialogStatus = 'create';
    _this.textMap = {
      update: '编辑地址',
      create: '新增地址'
    };
    _this.isEdit = false;
    // 有无数据
    _this.isNodata = false;
    _this.ruleForm = {
      realName: '',
      cityId: '',
      cityName: '',
      areaId: '',
      areaName: '',
      address: '',
      telephone: '',
      defaultAddress: 0,
      provinceId: '',
      provinceName: '',
      addressTemp: ''
    };
    _this.options = [];
    _this.cityOptions = [];
    _this.areaOptions = [];
    _this.menus = [{
      name: '个人账户',
      isOpen: true,
      child: [{
        id: 1,
        name: '个人中心'
      }, {
        id: 2,
        name: '个人信息'
      }, {
        id: 3,
        name: '安全设置'
      }, {
        id: 4,
        name: '地址管理'
      }]
    }, {
      name: '交易管理',
      isOpen: true,
      child: [{
        id: 5,
        name: '我的订单'
      }, {
        id: 6,
        name: '售后服务'
      }]
    }, {
      name: '客户服务',
      isOpen: true,
      child: [{
        id: 7,
        name: '发票资质'
      }]
    }];
    _this.value = [];
    _this.showDialogBack = false;
    _this.infoList = []; // 价格列表
    _this.ordernumber = {};
    _this.province = [];
    _this.sheng = '';
    _this.qu = '';
    _this.E = '';
    _this.shi1 = [];
    _this.qu1 = [];
    _this.city = [];
    _this.block = [];
    _this.addressList = [];
    _this.currentIndex = 4;
    _this.listQuery = {
      pageNo: 1,
      pageSize: 20
    };
    _this.rules = {
      realName: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }],
      telephone: [{
        required: true,
        validator: validateTelPhone,
        trigger: 'blur'
      }],
      areaId: [{
        required: true,
        message: '请选择地址'
      }],
      addressTemp: [{
        required: true,
        message: '请输入详细地址',
        trigger: 'blur'
      }]
    };
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getCityData();
      this.addressLists();
      this.pageVisit();
    }
  }, {
    key: "addressLists",
    value: function () {
      var _addressLists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return addressList(this.listQuery);
            case 2:
              res = _context.sent;
              this.addressList = res.data.data;
              this.isNodata = res.data.data.length === 0;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function addressLists() {
        return _addressLists.apply(this, arguments);
      }
      return addressLists;
    }()
  }, {
    key: "changeChild",
    value: function () {
      var _changeChild = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(index) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.currentIndex = index;
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function changeChild(_x) {
        return _changeChild.apply(this, arguments);
      }
      return changeChild;
    }()
  }, {
    key: "openAdd",
    value: function openAdd() {
      var _this2 = this;
      this.value = [];
      this.dialogStatus = 'create';
      this.showDialogBack = true;
      this.$nextTick(function () {
        var form = _this2.$refs.ruleForm;
        form.resetFields();
        _this2.ruleForm = {
          realName: '',
          cityId: '',
          cityName: '',
          areaId: '',
          areaName: '',
          address: '',
          telephone: '',
          defaultAddress: 0,
          provinceId: '',
          provinceName: '',
          addressTemp: ''
        };
      });
    }
  }, {
    key: "openEdit",
    value: function openEdit(item) {
      var _this3 = this;
      this.ruleForm = {
        id: item.id,
        realName: item.realName,
        cityId: item.cityCode,
        cityName: item.cityName,
        areaId: item.areaCode,
        areaName: item.areaName,
        address: item.address,
        telephone: item.telephone,
        defaultAddress: item.defaultAddress,
        provinceId: item.provinceCode,
        provinceName: item.provinceName,
        addressTemp: item.address.split("".concat(item.provinceName).concat(item.cityName).concat(item.areaName))[1]
      };
      this.cityOptions = this.options.filter(function (e) {
        return e.value === _this3.ruleForm.provinceId;
      })[0].children;
      this.areaOptions = this.cityOptions.filter(function (e) {
        return e.value === _this3.ruleForm.cityId;
      })[0].children;
      this.dialogStatus = 'upadate';
      this.showDialogBack = true;
      this.pageVisit();
    }
    // 选择省份
  }, {
    key: "chooseProvince",
    value: function chooseProvince(id) {
      var _this4 = this;
      this.ruleForm.provinceName = this.options.filter(function (e) {
        return e.value === id;
      })[0].label;
      this.ruleForm.cityId = this.options.filter(function (e) {
        return e.value === id;
      })[0].children[0].value;
      this.ruleForm.cityName = this.options.filter(function (e) {
        return e.value === id;
      })[0].children[0].label;
      this.cityOptions = this.options.filter(function (e) {
        return e.value === id;
      })[0].children;
      this.areaOptions = this.cityOptions.filter(function (e) {
        return e.value === _this4.ruleForm.cityId;
      })[0].children;
      this.ruleForm.areaId = this.cityOptions.filter(function (e) {
        return e.value === _this4.ruleForm.cityId;
      })[0].children[0].value;
      this.ruleForm.areaName = this.cityOptions.filter(function (e) {
        return e.value === _this4.ruleForm.cityId;
      })[0].children[0].label;
      this.$nextTick(function () {
        _this4.$refs.ruleForm.clearValidate('areaId');
      });
    }
    // 选择市
  }, {
    key: "chooseCity",
    value: function chooseCity(id) {
      var _this5 = this;
      this.ruleForm.cityName = this.cityOptions.filter(function (e) {
        return e.value === id;
      })[0].label;
      this.areaOptions = this.cityOptions.filter(function (e) {
        return e.value === id;
      })[0].children;
      this.ruleForm.areaId = this.cityOptions.filter(function (e) {
        return e.value === id;
      })[0].children[0].value;
      this.ruleForm.areaName = this.cityOptions.filter(function (e) {
        return e.value === id;
      })[0].children[0].label;
      this.$nextTick(function () {
        _this5.$refs.ruleForm.clearValidate('areaId');
      });
    }
    // 选择区
  }, {
    key: "chooseArea",
    value: function chooseArea(id) {
      var _this6 = this;
      this.ruleForm.areaName = this.areaOptions.filter(function (e) {
        return e.value === id;
      })[0].label;
      this.$nextTick(function () {
        _this6.$refs.ruleForm.clearValidate('areaId');
      });
    }
    // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: this.isEdit ? 12 : 11,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
    // 删除地址信息
  }, {
    key: "openDelete",
    value: function () {
      var _openDelete = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id) {
        var _this7 = this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$msgbox({
                title: '消息',
                message: '删除后将无法恢复，是否继续？',
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: function () {
                  var _beforeClose = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(action, instance, done) {
                    var res;
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(action === 'confirm')) {
                            _context3.next = 7;
                            break;
                          }
                          _context3.next = 3;
                          return deleteAdress({
                            id: id
                          });
                        case 3:
                          res = _context3.sent;
                          if (res.data.code === 100) {
                            done();
                            _this7.$message.success('删除成功');
                            _this7.addressLists();
                          } else {
                            done();
                            _this7.$message.error(res.data.message);
                          }
                          _context3.next = 8;
                          break;
                        case 7:
                          done();
                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function beforeClose(_x3, _x4, _x5) {
                    return _beforeClose.apply(this, arguments);
                  }
                  return beforeClose;
                }()
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function openDelete(_x2) {
        return _openDelete.apply(this, arguments);
      }
      return openDelete;
    }() // 设为默认地址
  }, {
    key: "updateDefaultData",
    value: function () {
      var _updateDefaultData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(item) {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              anchor = readCookie('anchor');
              if (!(item.defaultAddress !== 1)) {
                _context5.next = 7;
                break;
              }
              this.ruleForm = {
                id: item.id,
                realName: item.realName,
                cityId: item.cityCode,
                cityName: item.cityName,
                areaId: item.areaCode,
                areaName: item.areaName,
                address: item.address,
                telephone: item.telephone,
                defaultAddress: 1,
                provinceId: item.provinceCode,
                provinceName: item.provinceName,
                addressTemp: item.address.split("".concat(item.provinceName).concat(item.cityName).concat(item.areaName))[1]
              };
              _context5.next = 5;
              return saveAddress(this.ruleForm);
            case 5:
              res = _context5.sent;
              if (res.data.code === 100) {
                this.showDialogBack = false;
                getDataAddress({
                  equip: anchor ? anchor.equip : 4,
                  version: anchor ? anchor.version : '',
                  src: anchor ? anchor.src ? anchor.src : 2 : 4,
                  model: anchor ? anchor.model : '',
                  equipVersion: anchor ? anchor.equipVersion : '',
                  equipMeid: anchor ? anchor.equipMeid : '',
                  eventNo: '3.1.2.0.0.0.1',
                  provinceName: item.provinceCode,
                  cityName: item.cityCode,
                  country: item.cityCode,
                  companyId: 1
                });
                this.addressLists();
                this.$message.success('修改成功');
              } else {
                this.$message.error(res.data.message);
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateDefaultData(_x6) {
        return _updateDefaultData.apply(this, arguments);
      }
      return updateDefaultData;
    }() // 修改地址
  }, {
    key: "updateData",
    value: function () {
      var _updateData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this8 = this;
        var anchor, form;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              anchor = readCookie('anchor');
              form = this.$refs.ruleForm;
              form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!valid) {
                          _context6.next = 7;
                          break;
                        }
                        _this8.isEdit = true;
                        _this8.ruleForm.address = "".concat(_this8.ruleForm.provinceName).concat(_this8.ruleForm.cityName).concat(_this8.ruleForm.areaName).concat(_this8.ruleForm.addressTemp);
                        _context6.next = 5;
                        return saveAddress(_this8.ruleForm);
                      case 5:
                        res = _context6.sent;
                        if (res.data.code === 100) {
                          getDataAddress({
                            equip: anchor ? anchor.equip : 4,
                            version: anchor ? anchor.version : '',
                            src: anchor ? anchor.src ? anchor.src : 2 : 4,
                            model: anchor ? anchor.model : '',
                            equipVersion: anchor ? anchor.equipVersion : '',
                            equipMeid: anchor ? anchor.equipMeid : '',
                            eventNo: '3.1.2.0.0.0.2',
                            provinceName: _this8.ruleForm.provinceId,
                            cityName: _this8.ruleForm.cityId,
                            country: _this8.ruleForm.areaId,
                            companyId: 1
                          });
                          _this8.showDialogBack = false;
                          _this8.addressLists();
                          _this8.pageVisit();
                          _this8.$message.success('修改成功');
                        } else {
                          _this8.$message.error(res.data.message);
                        }
                      case 7:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x7) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this9 = this;
        var anchor, form;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              anchor = readCookie('anchor');
              form = this.$refs.ruleForm;
              form.validate(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!valid) {
                          _context8.next = 7;
                          break;
                        }
                        _this9.ruleForm.address = _this9.ruleForm.provinceName + _this9.ruleForm.cityName + _this9.ruleForm.areaName + _this9.ruleForm.addressTemp;
                        if (_this9.isNodata) {
                          _this9.ruleForm.defaultAddress = 1;
                        }
                        _context8.next = 5;
                        return saveAddress(_this9.ruleForm);
                      case 5:
                        res = _context8.sent;
                        if (res.data.code === 100) {
                          getDataAddress({
                            equip: anchor ? anchor.equip : 4,
                            version: anchor ? anchor.version : '',
                            src: anchor ? anchor.src ? anchor.src : 2 : 4,
                            model: anchor ? anchor.model : '',
                            equipVersion: anchor ? anchor.equipVersion : '',
                            equipMeid: anchor ? anchor.equipMeid : '',
                            eventNo: '3.1.2.0.0.0.2',
                            provinceName: _this9.ruleForm.provinceId,
                            cityName: _this9.ruleForm.cityId,
                            country: _this9.ruleForm.areaId,
                            companyId: 1
                          });
                          _this9.showDialogBack = false;
                          _this9.addressLists();
                          _this9.$message.success('添加成功');
                        } else {
                          _this9.$message.error(res.data.message);
                        }
                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x8) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "getCityData",
    value: function () {
      var _getCityData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.options = addData.data;
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getCityData() {
        return _getCityData.apply(this, arguments);
      }
      return getCityData;
    }() // 确认订单选择地址列表
    //  选择收货地址
  }, {
    key: "selectAddress",
    value: function selectAddress(item) {
      var id = this.$route.query.id;
      if (id === '0') {
        this.SELECTADDRESS([{
          id: item.id,
          address: item.address,
          realName: item.realName,
          telephone: item.telephone,
          defaultAddress: item.defaultAddress,
          select: true
        }]);
        this.$router.back();
      }
    }
  }]);
}(Vue);
__decorate([Mutation('address/SELECTADDRESS')], default_1.prototype, "SELECTADDRESS", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;